export const CHECK_FOR_UPDATE_TOPIC = 'check_for_update_topic';
export const NB_CAMPAIGNS_SEARCH_RESULT_CHANGED_TOPIC = 'nb-results-changed'
export const NB_RECORDS_SEARCH_RESULT_CHANGED_TOPIC = 'nb-results-changed'
export const FORCE_CLOSE_MENU_TOPIC = 'force_close_menu_topic';
export const SAVE_CURRENT_RECORD_TOPIC = 'save_current_record_topic'
export const REPORT_EDITOR_OPEN_ALL_TABS_TOPIC = 'open_section_topic';
export const TRANSITION_RECORD_TO_STATE = 'transition-record-to-validated'
export const OPEN_ADD_ITEM_MODAL = 'open-add_item-modal'
export const PUSH_SYNCHRO_PERFORMED = 'push-synchro-performed'
export const NB_ITEMS_SEARCH_RESULT_CHANGED_TOPIC = 'nb-results-changed'
export const OPEN_AUDIT_CAMPAIGN_POP_UP = 'open-audit-campaign-pop-up'